(function () {
  function buildDiscountRequest(code, root) {
    const normalizedRoot = root || '/';

    return {
      url: `${normalizedRoot}cart/update.js`,
      options: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: String(code || '').trim() }),
      },
    };
  }

  function getSelectedDiscountCode(quantityBreaks) {
    const selectedOffer = quantityBreaks.querySelector('input[name="quantity"]:checked + .quantity-break');
    return selectedOffer?.dataset.discountCode?.trim() || '';
  }

  function applySelectedDiscount(quantityBreaks, force) {
    const code = getSelectedDiscountCode(quantityBreaks);

    if (!code && !quantityBreaks.dataset.appliedDiscountCode) return Promise.resolve();
    if (!force && quantityBreaks.dataset.appliedDiscountCode === code) return Promise.resolve();

    quantityBreaks.dataset.appliedDiscountCode = code;
    const request = buildDiscountRequest(code, window.Shopify?.routes?.root || '/');

    return fetch(request.url, request.options).catch(() => {
      delete quantityBreaks.dataset.appliedDiscountCode;
    });
  }

  function initializeQuantityBreakDiscounts() {
    document.querySelectorAll('quantity-breaks').forEach((quantityBreaks) => {
      quantityBreaks.addEventListener('change', (event) => {
        if (event.target.matches('input[name="quantity"]')) {
          applySelectedDiscount(quantityBreaks);
        }
      });

      applySelectedDiscount(quantityBreaks);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        document.querySelectorAll('quantity-breaks').forEach((quantityBreaks) => {
          applySelectedDiscount(quantityBreaks, true);
        });
      });
    }
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeQuantityBreakDiscounts);
    } else {
      initializeQuantityBreakDiscounts();
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      buildDiscountRequest,
      getSelectedDiscountCode,
    };
  }
})();
